import { REVIEWS_REDIRECT_MAP } from './reviews';

export default {
  devLinks: 'DEV_LINKS',
};

export const ALT_IMAGE_ORIENTATION = {
  horizontal: 'HORIZONTAL',
  vertical: 'VERTICAL',
};

// NOTE: This flag will give false positives for home products with images that have taller than square aspect ratios (e.g. bathrobes)
export const CATEGORIES = {
  HOME: '3865',
};

export const FREE_SHIPPING_LINK = '/m/campaign/free-shipping/free-shipping-everyday?LinkType=Homepage&cm_re=2.2.16.1--HOMEPAGE_INCLUDE_1--CATEGORY%20-%205125%20-%20:details';

export const REDIRECT_MAP = {
  back: '/',
  signIn: '/account/signin',
  loyaltySignIn: '/account/signin', // As for now, loyalty sign in the same as sign in
  reviews: {
    ...REVIEWS_REDIRECT_MAP,
  },
};

export const STRING_SHORT_ANSWERS = {
  YES: 'Yes',
  NO: 'No',
};

export const BOOLEAN_SHORT_ANSWERS = {
  [STRING_SHORT_ANSWERS.YES]: true,
  [STRING_SHORT_ANSWERS.NO]: false,
};
